var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 5120 5120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l2AOBPITebsjLjoI4Hfp96D",
    fill: "rgb(154,3,212)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p59sAD4iS",
    d: "M3757 1362 c-680 -680 -997 -1004 -997 -1018 0 -19 3 -20 73 -12 542 63 1086 356 1438 776 278 332 470 768 516 1175 9 74 8 77 -11 77 -14 0 -339 -318 -1019 -998z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l7GmISoUQy7Go6boJ3uycDj",
    fill: "rgb(168,7,200)",
    style: {
      transform: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1G7Du13PY",
    d: "M3567 1552 c-658 -658 -1197 -1205 -1197 -1214 0 -14 14 -17 96 -20 53 -2 145 -1 205 2 l109 5 1008 1007 1007 1008 5 109 c3 60 4 152 2 205 -3 82 -6 96 -20 96 -9 0 -556 -539 -1215 -1198z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l3tPPPfKBdlQcG4kTaT4Wti",
    fill: "rgb(182,11,189)",
    style: {
      transform: "none"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pSviOzegU",
    d: "M4248 2633 l-466 -468 -4 -105 c-13 -304 -224 -578 -526 -683 -69 -24 -109 -31 -192 -35 l-105 -4 -467 -466 c-258 -257 -468 -472 -468 -478 0 -17 156 -50 320 -68 l55 -7 1203 1204 1203 1204 -14 114 c-20 148 -46 259 -60 259 -7 0 -222 -210 -479 -467z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lEvj5C3IQEKADcN11tRfzJ",
    fill: "rgb(195,15,178)",
    style: {
      transform: "none"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1EiTfJIdP",
    d: "M4207 2932 l-427 -427 0 -198 c0 -168 2 -197 15 -197 8 0 15 6 15 13 0 6 209 221 465 477 322 322 465 471 465 486 0 38 -80 274 -93 274 -7 0 -204 -192 -440 -428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plyFAANdV",
    d: "M3387 2112 c-115 -116 -125 -136 -93 -197 13 -25 13 -32 0 -57 -22 -43 -59 -56 -96 -35 -58 33 -75 26 -191 -91 -94 -94 -107 -112 -107 -141 l0 -34 133 6 c183 7 264 37 369 135 108 100 147 200 155 390 l6 132 -34 0 c-30 0 -47 -13 -142 -108z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBwkxs6vX",
    d: "M3760 1930 c-7 -44 -17 -80 -22 -80 -4 0 -8 -11 -8 -25 0 -14 -4 -25 -8 -25 -13 0 -32 -48 -32 -80 0 -17 4 -30 9 -30 16 0 70 123 91 206 25 96 25 114 2 114 -15 0 -21 -14 -32 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjgJLIdME",
    d: "M3620 1620 c0 -25 -4 -30 -23 -30 -27 0 -77 -48 -77 -73 0 -11 -8 -17 -25 -17 -21 0 -25 -5 -25 -31 l0 -30 33 22 c39 28 126 116 156 158 l22 31 -30 0 c-28 0 -31 -3 -31 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12BhTTbSE",
    d: "M3343 1418 c-13 -6 -23 -15 -23 -20 0 -4 -11 -8 -25 -8 -14 0 -25 -4 -25 -8 0 -4 -34 -14 -75 -21 -62 -11 -75 -17 -75 -32 0 -24 9 -24 104 1 83 21 206 75 206 91 0 12 -59 10 -87 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13yhgGdff",
    d: "M2187 912 c-235 -235 -427 -433 -427 -439 0 -13 237 -93 274 -93 15 0 164 143 486 465 256 256 471 465 477 465 7 0 13 7 13 15 0 13 -29 15 -198 15 l-197 0 -428 -428z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l1CMBeeQF1hF8pI9ZOoXssc",
    fill: "rgb(205,18,170)",
    style: {
      transform: "none"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1C20U54C4",
    d: "M4162 3187 l-382 -382 0 -178 c0 -151 2 -177 15 -177 8 0 15 6 15 13 0 6 193 205 429 441 409 409 429 430 420 455 -34 90 -93 211 -103 211 -6 0 -183 -172 -394 -383z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2l8dXCZ1",
    d: "M3047 2072 c-406 -406 -447 -450 -447 -480 l0 -32 179 0 c146 0 181 3 191 15 11 13 8 15 -16 15 -27 0 -21 8 80 108 l108 109 36 -19 c40 -21 80 -18 119 7 32 21 29 35 -7 35 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 5 -30 10 0 6 -6 10 -13 10 -19 0 -36 53 -24 76 13 26 49 54 68 54 9 0 28 -12 42 -26 15 -15 34 -24 46 -22 20 3 20 5 6 32 l-16 30 108 108 c100 100 108 107 111 83 3 -22 6 -24 18 -14 11 9 14 48 14 190 l0 179 -33 0 c-29 0 -73 -41 -480 -448z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp3mfjkRg",
    d: "M3526 2048 c-10 -38 -7 -48 14 -48 16 0 20 7 20 35 0 40 -24 49 -34 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHl2eZd7E",
    d: "M3498 1920 l-16 -50 23 0 c24 0 35 22 35 73 0 45 -25 31 -42 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paDl4L3km",
    d: "M3740 1845 c0 -39 14 -46 30 -16 16 31 12 51 -10 51 -16 0 -20 -7 -20 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUzJERAdg",
    d: "M3442 1810 l-32 -50 30 0 c20 0 30 5 30 15 0 8 5 15 10 15 6 0 10 16 10 35 0 19 -3 35 -7 35 -5 0 -23 -23 -41 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FToOgA2A",
    d: "M3308 1677 c-26 -18 -48 -35 -48 -39 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 10 0 15 10 15 30 0 17 -1 30 -2 29 -2 0 -24 -15 -50 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkKIuMGQZ",
    d: "M3198 1621 c-65 -20 -66 -46 -3 -38 53 5 58 9 53 34 -3 18 -5 18 -50 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAWjbg5Sb",
    d: "M3068 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqgE0Wcy1",
    d: "M3240 1360 c0 -22 20 -26 51 -10 30 16 23 30 -16 30 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDmGiWnn9",
    d: "M3110 1330 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDptohEYs",
    d: "M1932 957 c-210 -210 -382 -387 -382 -393 0 -10 121 -69 211 -103 25 -9 46 11 455 420 236 236 435 429 441 429 7 0 13 7 13 15 0 13 -26 15 -178 15 l-177 0 -383 -383z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5gSfX251S3HbTIZ9PPF58t",
    fill: "rgb(216,22,161)",
    style: {
      transform: "none"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pmMTCoo97",
    d: "M4107 3452 l-327 -327 0 -188 c0 -160 2 -187 15 -187 8 0 15 6 15 12 0 7 173 186 385 398 l385 385 -66 118 c-37 64 -70 117 -73 117 -3 0 -153 -147 -334 -328z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8DVKj74r",
    d: "M3333 2678 l-162 -163 -16 -69 c-51 -226 -255 -430 -481 -481 l-69 -16 -162 -162 c-144 -143 -163 -166 -163 -194 l0 -33 189 0 c151 0 191 3 200 14 10 12 8 15 -14 18 -22 3 26 55 425 453 398 397 450 447 450 421 0 -24 2 -27 15 -16 12 10 15 46 15 201 l0 189 -33 0 c-28 0 -51 -19 -194 -162z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2PviG0Qi",
    d: "M3526 2033 c-19 -98 -19 -103 2 -103 15 0 21 9 26 46 3 26 6 55 6 65 0 29 -28 22 -34 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8KCmFBli",
    d: "M3762 1955 c-16 -83 -15 -105 2 -105 14 0 28 43 41 128 6 37 4 42 -12 42 -15 0 -21 -13 -31 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pde0g9Q2w",
    d: "M3210 1993 c-39 -12 -63 -30 -76 -55 -39 -76 12 -161 96 -161 86 0 137 89 93 163 -22 38 -78 65 -113 53z m58 -54 c2 -5 10 -9 18 -9 9 0 14 -11 14 -35 0 -43 -32 -78 -70 -78 -34 0 -70 35 -70 68 0 25 25 58 51 68 17 6 53 -2 57 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9Anma33G",
    d: "M3720 1794 c0 -44 18 -42 37 4 13 31 12 32 -12 32 -22 0 -25 -4 -25 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BqCaQUth",
    d: "M3380 1736 l-44 -46 36 0 c43 0 60 18 56 60 l-3 31 -45 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peBkScOM1",
    d: "M3660 1695 c0 -8 -4 -15 -10 -15 -5 0 -10 -9 -10 -20 0 -11 -7 -20 -15 -20 -10 0 -15 -11 -15 -35 0 -19 2 -35 5 -35 8 0 95 121 95 131 0 5 -11 9 -25 9 -16 0 -25 -6 -25 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pASf69tx6",
    d: "M3145 1605 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12UEWJIMV",
    d: "M3480 1495 c0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 4 -25 9 -25 10 0 131 87 131 95 0 3 -16 5 -35 5 -24 0 -35 -5 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ED9iYl3t",
    d: "M3290 1375 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13EXo6Rim",
    d: "M3153 1357 c-42 -8 -53 -15 -53 -30 0 -17 5 -18 43 -12 84 13 127 27 127 41 0 16 -37 16 -117 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK3vQrHA0",
    d: "M1665 1010 c-181 -181 -327 -332 -323 -335 3 -3 57 -35 119 -71 l114 -64 385 385 c212 212 391 385 398 385 6 0 12 7 12 15 0 13 -28 15 -188 15 l-187 0 -330 -330z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l3nA8q9qbr88out2DS29YdB",
    fill: "rgb(227,25,152)",
    style: {
      transform: "none"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pCcTILBYm",
    d: "M4022 3657 c-325 -325 -310 -303 -277 -411 8 -27 20 -78 26 -112 7 -43 16 -64 25 -64 8 0 14 6 14 12 0 7 147 160 327 340 l327 327 -57 83 c-65 94 -83 118 -88 118 -2 0 -136 -132 -297 -293z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLu9TrALl",
    d: "M3318 2953 c-189 -189 -178 -167 -156 -319 10 -71 9 -93 -6 -165 -26 -122 -30 -159 -17 -159 15 0 36 50 50 120 11 54 17 61 176 220 150 150 165 162 165 136 0 -24 2 -27 15 -16 13 11 15 40 13 179 l-3 166 -35 3 c-33 3 -44 -6 -202 -165z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18BoZlm6F",
    d: "M2742 2377 c-145 -146 -162 -166 -162 -196 l0 -34 59 6 c168 15 310 156 327 325 l7 62 -34 0 c-31 0 -50 -16 -197 -163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D8yyX9KE",
    d: "M3070 2245 c0 -8 -4 -15 -10 -15 -5 0 -10 -9 -10 -20 0 -11 -7 -20 -15 -20 -10 0 -15 -11 -15 -35 0 -19 2 -35 5 -35 8 0 95 121 95 131 0 5 -11 9 -25 9 -16 0 -25 -6 -25 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8kS4be0K",
    d: "M2930 2085 c0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 4 -25 9 -25 10 0 131 87 131 95 0 3 -16 5 -35 5 -24 0 -35 -5 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLSl0Z8mY",
    d: "M3526 2028 c-10 -38 -7 -48 14 -48 16 0 20 7 20 35 0 40 -24 49 -34 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX1ToOZf1",
    d: "M3766 1984 c-9 -69 -8 -84 8 -84 14 0 18 11 32 93 5 32 4 37 -14 37 -15 0 -21 -9 -26 -46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HcKwSX0p",
    d: "M2675 1968 c-71 -19 -89 -19 -268 -2 l-69 7 -169 -169 c-147 -147 -169 -173 -169 -200 0 -20 6 -34 16 -38 9 -3 84 -6 169 -6 123 0 155 3 165 15 11 13 8 15 -16 15 -26 0 -14 15 136 165 159 159 166 165 220 176 69 14 120 35 120 48 0 16 -55 11 -135 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdMVH1Boa",
    d: "M3148 1953 c-29 -34 -30 -53 -3 -53 22 0 25 4 25 35 0 40 -1 41 -22 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLnHO3jTF",
    d: "M3510 1946 c0 -34 -75 -159 -126 -210 -51 -51 -176 -126 -210 -126 -8 0 -14 -7 -14 -15 0 -10 11 -15 35 -15 19 0 35 5 35 10 0 6 9 10 19 10 30 0 51 11 51 26 0 8 10 14 25 14 15 0 25 6 25 14 0 8 10 16 23 18 14 2 23 11 25 25 2 14 11 23 25 25 14 2 23 11 25 26 2 12 10 22 18 22 8 0 14 10 14 25 0 15 6 25 14 25 15 0 26 21 26 51 0 10 5 19 10 19 6 0 10 16 10 35 0 24 -5 35 -15 35 -8 0 -15 -6 -15 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnugPKSAo",
    d: "M3736 1868 c-9 -36 -7 -78 5 -78 11 0 39 60 39 85 0 24 -37 18 -44 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7R1gXcw8",
    d: "M3670 1695 c0 -43 10 -44 33 -6 22 38 22 41 -8 41 -22 0 -25 -4 -25 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8CeMkVOk",
    d: "M3088 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVzL763eB",
    d: "M3390 1425 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8LlJwRjs",
    d: "M1460 1095 c-281 -281 -294 -295 -275 -310 11 -8 57 -41 103 -72 l83 -57 327 327 c180 180 333 327 340 327 6 0 12 6 12 14 0 9 -21 18 -64 25 -34 6 -85 18 -112 26 -109 33 -86 48 -414 -280z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plMeSqwzT",
    d: "M3260 1365 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EMhmN6hl",
    d: "M3090 1330 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l6ITQHWATy7wYta83MY02CD",
    fill: "rgb(235,27,144)",
    style: {
      transform: "none"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p17kZAoaRq",
    d: "M3917 3802 c-240 -240 -277 -281 -277 -307 0 -17 23 -74 50 -128 28 -54 50 -104 50 -112 0 -8 9 -15 20 -15 23 0 25 13 9 60 l-12 32 293 293 c227 227 290 296 284 308 -17 30 -119 146 -129 146 -6 1 -135 -124 -288 -277z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTFD4nnm0",
    d: "M3242 3127 c-132 -132 -182 -189 -182 -206 0 -12 18 -60 40 -105 23 -44 46 -109 53 -144 9 -50 15 -62 30 -62 16 0 18 5 13 33 -3 17 -8 50 -11 72 l-6 40 171 170 c151 151 171 167 176 148 9 -34 34 -29 34 7 0 44 -20 129 -42 183 -19 44 -23 47 -57 47 -34 0 -49 -13 -219 -183z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16SNi13W1",
    d: "M3760 3211 c0 -10 3 -39 6 -65 5 -37 11 -46 26 -46 21 0 21 5 2 103 -6 30 -34 37 -34 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phNj2mMEx",
    d: "M2625 2510 c-137 -137 -258 -250 -267 -250 -14 0 -18 -8 -18 -34 0 -32 3 -36 53 -54 74 -28 171 -36 256 -22 64 11 71 14 71 35 0 23 -1 23 -47 9 -25 -8 -51 -14 -57 -14 -6 0 63 74 154 165 90 90 165 163 167 161 1 -1 -3 -26 -11 -54 -13 -51 -13 -52 10 -52 20 0 23 7 34 71 14 79 8 168 -16 242 -14 43 -18 47 -47 47 -29 0 -60 -28 -282 -250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p073Dr5Pe",
    d: "M3160 2485 c0 -40 24 -49 34 -12 10 37 7 47 -14 47 -16 0 -20 -7 -20 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTOzyM57o",
    d: "M3140 2390 c0 -16 -4 -30 -10 -30 -5 0 -10 -16 -10 -35 0 -19 5 -35 11 -35 11 0 37 55 46 101 5 25 2 29 -16 29 -17 0 -21 -6 -21 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSsRb2IwH",
    d: "M2790 2250 l-35 -29 38 -1 c35 0 37 2 37 30 0 17 -1 30 -3 30 -1 0 -18 -13 -37 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pskdAThQQ",
    d: "M3010 2144 c0 -39 9 -38 40 6 l21 30 -30 0 c-29 0 -31 -3 -31 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfcM1KFJl",
    d: "M1992 1877 c-169 -169 -182 -185 -182 -218 0 -34 3 -38 48 -57 92 -39 222 -55 222 -28 0 8 -12 17 -27 21 -25 6 -20 13 143 176 l169 170 40 -6 c22 -3 55 -8 73 -11 27 -5 32 -3 32 13 0 15 -12 21 -62 30 -35 7 -100 30 -144 53 -45 22 -93 40 -106 40 -17 0 -72 -49 -206 -183z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4VtfpORA",
    d: "M3526 2018 c-10 -38 -7 -48 14 -48 16 0 20 7 20 35 0 40 -24 49 -34 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEBcKk5se",
    d: "M3770 2005 c0 -40 24 -49 34 -12 10 37 7 47 -14 47 -16 0 -20 -7 -20 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prd3PnbN0",
    d: "M2760 1990 c0 -5 -13 -10 -30 -10 -24 0 -30 -4 -30 -21 0 -18 4 -21 29 -16 46 9 101 35 101 46 0 6 -16 11 -35 11 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16GZxsK44",
    d: "M3290 1937 c0 -32 3 -37 24 -37 19 0 23 4 19 19 -3 11 -14 27 -24 37 -18 17 -19 16 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcLWoLd3E",
    d: "M2610 1940 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10AYgL7Kk",
    d: "M3129 1919 c-14 -28 -4 -82 21 -104 19 -17 20 -17 20 1 0 46 -14 124 -21 124 -5 0 -13 -9 -20 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppzkhb2BO",
    d: "M3290 1833 c0 -35 1 -36 19 -19 10 10 21 26 24 37 4 15 0 19 -19 19 -21 0 -24 -5 -24 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19rkRrcyW",
    d: "M3710 1774 c0 -44 18 -42 37 4 13 31 12 32 -12 32 -22 0 -25 -4 -25 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyOK8foCQ",
    d: "M3098 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15lMbHt6Y",
    d: "M1318 1206 c-153 -155 -278 -286 -277 -291 0 -10 117 -112 146 -129 12 -6 81 57 308 284 l293 293 32 -12 c47 -16 60 -14 60 9 0 11 -6 20 -13 20 -17 0 -152 65 -187 90 -59 42 -63 39 -362 -264z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15SZeVtfb",
    d: "M3310 1385 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZn6gBjEj",
    d: "M3230 1360 c0 -22 20 -26 51 -10 30 16 23 30 -16 30 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjlaxRc1q",
    d: "M1890 1346 c0 -14 11 -18 93 -32 32 -5 37 -4 37 14 0 15 -9 21 -46 26 -69 9 -84 8 -84 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUJJvnf4Y",
    d: "M3150 1340 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lJyx1PBm4XYmso7bkO2clY",
    fill: "rgb(245,30,136)",
    style: {
      transform: "none"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p8x7373B1",
    d: "M3787 3942 c-323 -324 -314 -306 -224 -401 71 -77 97 -109 97 -121 0 -6 11 -10 25 -10 30 0 31 3 4 47 l-22 35 283 283 284 284 -79 80 c-43 45 -81 81 -84 81 -4 0 -131 -125 -284 -278z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqSyYtp8x",
    d: "M3290 3457 c0 -16 -341 -357 -358 -357 -7 0 -12 -12 -12 -28 0 -21 14 -43 53 -83 66 -68 97 -106 97 -119 0 -6 11 -10 25 -10 29 0 31 7 11 36 -14 19 -4 31 169 204 176 176 185 183 199 165 14 -19 15 -18 16 20 0 31 -8 50 -38 86 -54 68 -95 99 -131 99 -18 0 -31 -5 -31 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1NZPFSQk",
    d: "M3720 3326 c0 -32 3 -36 25 -36 24 0 25 1 12 32 -19 46 -37 48 -37 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp7DzVvNR",
    d: "M3750 3235 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgYQ4vtPS",
    d: "M3510 3180 c0 -37 24 -110 36 -110 15 0 17 23 8 83 -5 27 -11 37 -25 37 -11 0 -19 -4 -19 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AMalWxCu",
    d: "M3770 3125 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4lv6GxQp",
    d: "M2730 2902 c0 -22 -490 -512 -513 -512 -13 0 -17 -8 -17 -35 0 -19 5 -35 10 -35 6 0 10 -6 10 -14 0 -17 97 -106 116 -106 8 0 14 -4 14 -10 0 -5 11 -10 24 -10 13 0 26 -4 28 -10 9 -29 277 -39 286 -11 2 6 14 11 27 11 28 0 75 20 75 32 0 4 7 8 15 8 10 0 15 10 15 29 l0 30 -57 -35 c-32 -19 -76 -40 -98 -46 -59 -16 -164 -13 -224 7 l-53 17 258 259 259 259 13 -32 c49 -116 29 -258 -50 -370 l-19 -28 30 0 c26 0 31 4 31 25 0 15 6 25 14 25 16 0 26 21 26 55 0 13 6 25 13 27 8 3 12 34 12 109 0 122 -10 179 -30 179 -10 0 -15 10 -15 28 0 15 -7 39 -16 52 -28 41 -87 100 -101 100 -7 0 -13 5 -13 10 0 6 -16 10 -35 10 -27 0 -35 -4 -35 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19MdHGWPK",
    d: "M3120 2796 c0 -20 4 -36 8 -36 5 0 15 -36 22 -80 11 -67 17 -80 32 -80 17 0 18 5 12 48 -9 66 -47 175 -61 180 -9 2 -13 -8 -13 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9xcSkxB7",
    d: "M3150 2425 c0 -19 -4 -35 -10 -35 -5 0 -10 -9 -10 -21 0 -11 -7 -27 -15 -35 -8 -9 -15 -24 -15 -35 0 -10 -4 -19 -10 -19 -5 0 -10 -16 -10 -35 0 -19 4 -35 8 -35 20 0 102 191 102 237 0 7 -9 13 -20 13 -16 0 -20 -7 -20 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCUA60LmE",
    d: "M2020 2187 c0 -16 -341 -357 -358 -357 -7 0 -12 -13 -12 -31 0 -36 31 -77 99 -131 36 -30 55 -38 86 -38 38 1 39 2 20 16 -18 14 -11 23 165 199 173 173 185 183 204 169 29 -20 36 -18 36 11 0 14 -4 25 -10 25 -13 0 -51 31 -119 98 -40 38 -62 52 -83 52 -16 0 -28 -5 -28 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p09M74hqs",
    d: "M3000 2145 c0 -20 -5 -25 -25 -25 -28 0 -38 -16 -33 -50 3 -20 5 -19 40 10 21 17 47 44 58 60 l21 30 -30 0 c-26 0 -31 -4 -31 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptn1ADhU",
    d: "M2840 2025 c0 -10 -10 -15 -30 -15 -16 0 -30 -4 -30 -10 0 -5 -11 -10 -25 -10 -14 0 -25 -4 -25 -9 0 -5 -29 -12 -65 -16 -56 -6 -65 -9 -65 -27 0 -18 4 -19 43 -13 95 14 267 83 267 107 0 4 -16 8 -35 8 -24 0 -35 -5 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZpp7gwRF",
    d: "M2292 1988 c5 -15 114 -53 181 -62 42 -6 47 -5 47 12 0 15 -13 21 -80 32 -44 7 -80 17 -80 22 0 4 -16 8 -36 8 -24 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plGwdocFx",
    d: "M3178 1979 c-34 -20 -17 -29 52 -29 39 0 70 4 70 10 0 26 -87 40 -122 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK5r7myvO",
    d: "M3512 1947 c-6 -23 -23 -64 -37 -90 -14 -27 -25 -50 -25 -53 0 -2 11 -4 25 -4 21 0 25 5 25 30 0 20 5 30 15 30 10 0 15 10 15 30 0 17 5 30 10 30 6 0 10 16 10 35 0 50 -25 45 -38 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBxyT8p0d",
    d: "M3300 1884 c0 -40 3 -55 13 -52 21 8 32 54 19 83 -19 41 -32 29 -32 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EOViYDCp",
    d: "M3275 1650 c-16 -10 -55 -27 -87 -36 -65 -20 -78 -44 -23 -44 19 0 35 5 35 10 0 6 14 10 30 10 20 0 30 5 30 15 0 10 10 15 30 15 25 0 30 4 30 25 0 30 -6 31 -45 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRc0cPbfN",
    d: "M3600 1594 c0 -39 9 -38 40 6 l21 30 -30 0 c-29 0 -31 -3 -31 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF2jsItav",
    d: "M1175 1333 l-280 -284 83 -81 83 -82 284 285 284 284 33 -22 c41 -29 48 -29 48 2 0 16 -6 25 -15 25 -8 0 -15 5 -15 10 0 6 -5 10 -10 10 -6 0 -43 31 -83 70 -59 57 -78 69 -102 68 -25 -1 -73 -45 -310 -285z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFkwIaSGK",
    d: "M1930 1591 c0 -18 39 -31 98 -31 44 0 23 28 -28 39 -67 14 -70 14 -70 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poTJ7wGHs",
    d: "M3490 1489 l0 -30 30 21 c44 31 45 40 6 40 -33 0 -36 -2 -36 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2E0Vxpwc",
    d: "M1762 1388 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9NM1VnNR",
    d: "M1850 1356 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puAofA75z",
    d: "M1960 1336 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prwWZGFyU",
    d: "M3080 1330 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l13ih4jJkhAzYoxHdVTIZuw",
    fill: "rgb(253,35,129)",
    style: {
      transform: "none"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1DXhAB31g",
    d: "M3568 4083 c-238 -237 -298 -302 -297 -323 0 -21 11 -30 70 -58 38 -18 90 -49 114 -68 29 -22 56 -34 76 -34 27 0 30 2 18 16 -11 13 25 53 269 297 l282 282 -52 45 c-64 55 -171 140 -178 140 -3 0 -139 -134 -302 -297z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pI5TsWbBD",
    d: "M2875 3390 c-93 -93 -178 -170 -187 -170 -14 0 -18 -8 -18 -32 0 -31 3 -34 60 -52 67 -20 188 -89 208 -118 7 -10 24 -18 38 -18 19 0 24 -5 24 -26 0 -17 6 -28 20 -31 11 -3 20 -14 20 -24 0 -12 7 -19 20 -19 15 0 20 -7 20 -25 0 -28 30 -95 42 -95 4 0 8 -11 8 -25 0 -18 5 -25 20 -25 26 0 25 18 -4 84 -30 68 -76 136 -135 199 l-45 48 183 182 c100 101 178 187 174 192 -4 5 8 -4 27 -19 79 -64 149 -179 170 -283 8 -37 16 -53 27 -53 13 0 15 9 9 55 -7 62 -40 158 -62 179 -8 8 -14 19 -14 25 0 6 -6 11 -14 11 -8 0 -16 10 -18 23 -2 14 -11 23 -25 25 -15 2 -23 10 -23 23 0 12 -10 23 -25 29 -14 5 -25 14 -25 19 0 15 -117 67 -178 80 -118 25 -108 30 -297 -159z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7JMx8qa2",
    d: "M3600 3526 c0 -25 4 -36 15 -36 8 0 15 -9 15 -20 0 -13 7 -20 20 -20 16 0 20 -7 20 -30 0 -25 4 -30 25 -30 14 0 25 4 25 8 0 11 -96 148 -110 157 -6 4 -10 -8 -10 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p49iACmpC",
    d: "M3710 3346 c0 -19 3 -36 8 -38 9 -4 52 -168 52 -202 0 -20 5 -26 21 -26 18 0 20 4 14 48 -16 109 -63 252 -85 252 -5 0 -10 -15 -10 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18aVkKu0E",
    d: "M2479 2974 c-16 -3 -82 -60 -180 -157 l-153 -152 0 -110 c0 -89 5 -121 23 -167 12 -32 27 -58 32 -58 5 0 9 -7 9 -15 0 -10 10 -15 30 -15 28 0 29 2 18 20 -12 18 9 42 255 287 245 246 269 267 287 255 18 -11 20 -10 20 18 0 20 -5 30 -15 30 -8 0 -15 4 -15 9 0 5 -26 19 -57 31 -57 21 -196 34 -254 24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10vUjD48V",
    d: "M2868 2793 c11 -16 29 -47 41 -70 25 -50 41 -55 41 -13 0 32 -19 80 -32 80 -4 0 -8 7 -8 15 0 10 -10 15 -31 15 l-30 0 19 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pY02cCmDU",
    d: "M3150 2703 c0 -10 3 -42 6 -70 6 -44 10 -53 27 -53 17 0 19 5 12 48 -10 75 -16 92 -31 92 -8 0 -14 -8 -14 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph0dLNBRZ",
    d: "M2940 2628 c0 -30 13 -58 26 -58 9 0 14 12 14 35 0 28 -4 35 -20 35 -11 0 -20 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkWkM8ops",
    d: "M2946 2518 c-10 -38 -7 -48 14 -48 16 0 20 7 20 35 0 40 -24 49 -34 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmxLDcm99",
    d: "M3160 2523 c0 -10 -3 -42 -6 -70 -6 -44 -4 -53 9 -53 16 0 21 16 32 93 7 43 6 47 -14 47 -13 0 -21 -6 -21 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz9cwL5ya",
    d: "M1900 2432 c0 -9 -76 -94 -170 -187 -189 -189 -184 -179 -159 -297 13 -61 65 -178 80 -178 5 0 14 -11 19 -25 6 -15 17 -25 29 -25 13 0 21 -8 23 -22 2 -15 11 -24 26 -26 12 -2 22 -10 22 -18 0 -8 5 -14 11 -14 6 0 17 -6 25 -14 21 -22 117 -55 179 -62 46 -6 55 -4 55 9 0 11 -16 19 -53 27 -104 21 -219 91 -283 170 -15 19 -24 31 -19 27 5 -4 91 74 192 174 l182 183 48 -45 c63 -59 131 -105 199 -135 66 -29 84 -30 84 -4 0 15 -7 20 -25 20 -14 0 -25 5 -25 10 0 6 -13 10 -30 10 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -23 0 -30 4 -30 20 0 13 -7 20 -19 20 -10 0 -21 9 -24 20 -3 14 -14 20 -31 20 -21 0 -26 5 -26 24 0 14 -8 31 -18 38 -29 20 -98 141 -118 208 -18 57 -21 60 -51 60 -25 0 -33 -4 -33 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZGTTr4B0",
    d: "M2897 2371 c-22 -38 -22 -41 8 -41 22 0 25 4 25 35 0 43 -10 44 -33 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7jptEs8o",
    d: "M2830 2285 l-34 -35 37 0 c36 0 37 1 37 35 0 19 -1 35 -3 35 -2 0 -18 -16 -37 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p173QlhkMX",
    d: "M3090 2265 c0 -53 13 -46 48 28 2 4 -8 7 -22 7 -23 0 -26 -4 -26 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piOvRxl5v",
    d: "M2300 2240 c0 -20 5 -30 15 -30 8 0 15 -4 15 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 16 -10 35 -10 42 0 46 16 8 32 -16 7 -47 25 -70 41 l-43 28 0 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTT4CiMgw",
    d: "M3040 2190 c0 -25 -4 -30 -25 -30 -16 0 -25 -6 -25 -15 0 -8 -7 -15 -15 -15 -9 0 -15 -9 -15 -25 0 -21 -5 -25 -30 -25 -27 0 -30 -3 -30 -31 l0 -30 31 22 c39 28 120 109 148 148 l22 31 -30 0 c-28 0 -31 -3 -31 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFMVyh5al",
    d: "M2693 2198 c-45 -15 -43 -38 2 -38 31 0 35 3 35 25 0 14 -1 25 -2 24 -2 -1 -18 -6 -35 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJhBixgA0",
    d: "M2470 2160 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdtzjIhWj",
    d: "M2598 2173 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AuQxescc",
    d: "M2812 2021 c-8 -4 -12 -18 -10 -30 l3 -21 43 21 c23 12 42 25 42 30 0 11 -61 12 -78 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVXXBb81V",
    d: "M3185 1980 c-12 -4 -27 -15 -34 -24 -12 -14 -9 -16 23 -16 32 0 36 3 36 25 0 14 -1 25 -2 24 -2 0 -12 -4 -23 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px5IaZIvR",
    d: "M2400 1956 c0 -15 17 -21 93 -31 42 -7 47 -5 47 12 0 17 -9 21 -52 27 -76 9 -88 8 -88 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdiROuYWr",
    d: "M2580 1940 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Aa7cmbeY",
    d: "M3126 1905 c-8 -30 -1 -45 20 -45 9 0 14 11 14 35 0 42 -24 49 -34 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peBedjCc6",
    d: "M1031 1549 l-295 -298 57 -73 c32 -40 74 -92 95 -115 l38 -43 282 283 c187 188 285 280 292 273 7 -7 10 0 10 21 0 19 -16 55 -45 98 -24 37 -52 87 -62 111 -16 39 -21 44 -48 42 -25 -1 -76 -48 -324 -299z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10Hp20lIy",
    d: "M1565 1510 c3 -5 19 -19 35 -30 l30 -21 0 30 c0 29 -3 31 -36 31 -20 0 -33 -4 -29 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmfPDs2hl",
    d: "M1660 1442 c0 -8 52 -42 64 -42 3 0 6 11 6 25 0 22 -4 25 -35 25 -19 0 -35 -4 -35 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p95xVgrB1",
    d: "M1740 1400 c0 -12 79 -48 123 -57 23 -5 27 -2 27 16 0 17 -8 22 -40 27 -22 4 -40 10 -40 15 0 5 -16 9 -35 9 -19 0 -35 -5 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSo43hnPd",
    d: "M1900 1346 c0 -14 14 -19 98 -31 37 -6 42 -5 42 13 0 16 -9 20 -52 26 -76 9 -88 8 -88 -8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l2jeRY06uIkcTIYvccEhlKN",
    fill: "rgb(254,65,111)",
    style: {
      transform: "none"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p14L5umfCp",
    d: "M3357 4172 c-290 -290 -327 -331 -327 -358 0 -31 1 -32 63 -38 34 -4 101 -21 147 -37 47 -16 95 -33 108 -36 12 -3 22 -9 22 -14 0 -5 11 -9 25 -9 16 0 25 -6 25 -15 0 -8 7 -15 15 -15 8 0 15 -4 15 -10 0 -5 17 -10 38 -10 l37 1 -34 29 c-18 15 -68 46 -110 66 l-76 38 297 295 c224 222 295 298 287 307 -10 12 -193 134 -201 134 -2 0 -150 -147 -331 -328z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14iP50uYX",
    d: "M2578 3393 c-147 -148 -168 -172 -168 -200 l0 -32 108 2 c80 1 126 -3 182 -18 41 -11 77 -22 80 -26 11 -14 71 -39 95 -39 18 0 25 -5 25 -20 0 -16 7 -20 30 -20 25 0 30 -4 30 -25 0 -16 6 -25 15 -25 8 0 15 -7 15 -15 0 -10 10 -15 31 -15 29 0 30 1 15 23 -42 59 -188 156 -290 191 -17 6 7 34 155 182 l174 175 40 -7 c22 -3 64 -14 93 -24 l52 -18 0 24 c0 20 -5 24 -29 24 -16 0 -31 6 -33 13 -4 9 -61 13 -229 15 l-224 3 -167 -168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BUfqqxYG",
    d: "M3650 3456 c0 -25 4 -36 15 -36 9 0 15 -9 15 -25 0 -14 5 -25 10 -25 6 0 10 -9 10 -20 0 -15 7 -20 25 -20 22 0 24 2 15 26 -15 38 -59 110 -75 124 -13 11 -15 7 -15 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE8rijW9p",
    d: "M3315 3450 c3 -5 19 -19 35 -30 l30 -21 0 30 c0 29 -3 31 -36 31 -20 0 -33 -4 -29 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1JRSsHUL",
    d: "M3420 3350 c31 -44 40 -45 40 -6 0 33 -2 36 -31 36 l-30 0 21 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPbzVxhzg",
    d: "M2430 2964 c-154 -42 -267 -175 -286 -339 -6 -46 -4 -55 9 -55 10 0 18 12 22 34 5 26 40 66 158 185 83 83 158 151 167 151 31 0 60 13 60 26 0 18 -58 17 -130 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbFp7EO6W",
    d: "M2570 2966 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40 20 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8sqXa1FC",
    d: "M2660 2947 c0 -8 16 -18 35 -24 33 -11 35 -10 35 13 0 21 -5 24 -35 24 -22 0 -35 -5 -35 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11Pfbf3bH",
    d: "M2830 2835 c19 -19 35 -35 37 -35 2 0 3 16 3 35 0 34 -1 35 -37 35 l-37 0 34 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17R4OZ9F4",
    d: "M1727 2542 l-169 -169 4 -223 c2 -167 6 -224 16 -228 6 -2 12 -17 12 -33 0 -24 4 -29 24 -29 l24 0 -18 53 c-10 28 -21 70 -24 92 l-7 40 175 174 c148 148 176 172 182 155 35 -102 132 -248 192 -290 21 -15 22 -14 22 15 0 21 -5 31 -15 31 -8 0 -15 7 -15 15 0 9 -9 15 -25 15 -21 0 -25 5 -25 30 0 23 -4 30 -20 30 -15 0 -20 7 -20 29 0 16 -7 36 -15 45 -8 8 -15 22 -15 30 0 9 -3 16 -8 16 -19 0 -47 167 -44 268 l2 102 -33 0 c-28 0 -52 -19 -200 -168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCF7lHYRQ",
    d: "M2940 2638 c0 -30 13 -58 26 -58 9 0 14 12 14 35 0 28 -4 35 -20 35 -11 0 -20 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk5dEXnqt",
    d: "M2140 2520 c0 -16 5 -52 11 -80 9 -43 14 -50 34 -50 23 0 24 1 10 43 -7 23 -16 59 -20 80 -7 46 -35 52 -35 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peRXCNuvI",
    d: "M2250 2285 c0 -34 1 -35 37 -35 l37 0 -34 35 c-19 19 -35 35 -37 35 -2 0 -3 -16 -3 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paye10BzZ",
    d: "M946 1761 l-329 -329 62 -95 c34 -52 68 -100 75 -106 9 -8 86 63 309 287 242 242 297 293 301 277 8 -30 90 -165 125 -205 l30 -35 1 38 c0 26 -4 37 -15 37 -8 0 -15 9 -15 20 0 11 -4 20 -10 20 -5 0 -10 7 -10 15 0 8 -7 15 -15 15 -9 0 -15 9 -15 25 0 16 -6 25 -15 25 -8 0 -15 9 -15 19 0 11 -13 59 -29 108 -17 48 -33 116 -37 151 -7 61 -7 62 -38 62 -28 0 -68 -37 -360 -329z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1egayqJ7",
    d: "M2230 2021 c0 -5 19 -18 43 -30 l42 -21 3 21 c2 12 -2 26 -10 30 -17 12 -78 11 -78 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peeD5uGkl",
    d: "M1660 1776 c0 -33 2 -36 31 -36 l30 0 -21 30 c-31 44 -40 45 -40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxOdOcRcb",
    d: "M1610 1474 c14 -15 141 -94 153 -94 4 0 7 11 7 25 0 22 -4 25 -35 25 -28 0 -35 4 -35 20 0 11 -7 20 -15 20 -8 0 -15 5 -15 10 0 6 -16 10 -36 10 -32 0 -35 -2 -24 -16z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l2sOUT9746kwv8TVYX6GUBe",
    fill: "rgb(254,82,101)",
    style: {
      transform: "none"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pUJhOi0Ye",
    d: "M3202 4207 c-327 -327 -362 -365 -362 -395 l0 -32 113 -1 c61 0 135 -4 162 -9 119 -22 145 -24 145 -8 0 17 -53 33 -144 44 l-58 7 332 332 333 333 -39 25 c-21 13 -57 33 -80 45 l-40 21 -362 -362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phi1uH1yY",
    d: "M3350 3716 c0 -23 4 -26 35 -26 53 0 46 13 -27 48 -5 2 -8 -8 -8 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWGZwiXK7",
    d: "M2057 3062 l-497 -497 0 -123 c0 -102 2 -122 15 -122 8 0 15 6 15 13 0 7 77 89 171 182 l171 170 -7 -42 c-6 -38 -4 -43 12 -43 15 0 21 13 31 68 44 233 251 440 485 484 54 10 67 16 67 31 0 16 -5 18 -42 12 l-43 -7 170 171 c93 94 175 171 182 171 7 0 13 7 13 15 0 13 -20 15 -123 15 l-122 0 -498 -498z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p188m38pQU",
    d: "M3090 3546 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvf2kv61p",
    d: "M2590 3180 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBqhxeFsb",
    d: "M2470 2960 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR5JRgEop",
    d: "M2140 2615 c0 -40 24 -49 34 -12 10 37 7 47 -14 47 -16 0 -20 -7 -20 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19fMGTisr",
    d: "M1920 2518 c0 -30 13 -58 26 -58 9 0 14 12 14 35 0 28 -4 35 -20 35 -11 0 -20 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGkibsi4P",
    d: "M1972 2313 c35 -74 48 -81 48 -28 0 31 -3 35 -26 35 -14 0 -24 -3 -22 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVSPSuy9Y",
    d: "M913 1918 l-363 -363 36 -65 c20 -36 41 -71 47 -78 8 -10 85 61 342 318 l332 332 7 -58 c11 -91 27 -144 44 -144 16 0 14 26 -8 145 -5 28 -9 101 -9 163 l-1 112 -33 0 c-29 0 -66 -34 -394 -362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSmSr6TEw",
    d: "M1560 1995 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEndCGt7t",
    d: "M1380 1766 c13 -34 33 -66 42 -66 9 0 11 52 2 74 -3 9 -17 16 -30 16 -21 0 -22 -3 -14 -24z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l1x5LSHB3Xo56XuZktzAAzj",
    fill: "rgb(254,96,94)",
    style: {
      transform: "none"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "ppxhoNb7j",
    d: "M3047 4232 c-350 -350 -387 -390 -387 -420 l0 -32 119 0 c93 0 121 3 131 15 11 13 8 15 -16 15 -26 0 13 42 340 369 l370 370 -74 35 c-41 20 -79 36 -85 36 -5 0 -184 -174 -398 -388z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8Axqo6XB",
    d: "M3070 3790 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4regdJDC",
    d: "M1967 3152 l-407 -407 0 -118 c0 -97 3 -117 15 -117 8 0 15 6 15 13 0 16 991 1007 1008 1007 6 0 12 7 12 15 0 12 -20 15 -118 15 l-117 0 -408 -408z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pm3no2wXo",
    d: "M2478 3193 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prjbnTTd8",
    d: "M2580 3180 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvqCRUJJj",
    d: "M2271 3129 c-119 -58 -223 -162 -280 -281 -46 -95 -50 -118 -21 -118 15 0 20 7 20 25 0 14 5 25 10 25 6 0 10 14 10 30 0 20 5 30 15 30 8 0 17 11 21 24 3 14 12 27 20 30 8 3 14 11 14 18 0 7 9 19 20 26 11 7 20 23 20 37 0 20 5 25 25 25 14 0 30 9 37 20 7 11 18 20 25 20 7 0 16 6 20 13 4 7 32 23 61 36 28 14 52 28 52 33 0 4 11 8 25 8 18 0 25 5 25 20 0 29 -24 25 -119 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHcseRQkx",
    d: "M1926 2638 c-10 -38 -7 -48 14 -48 16 0 20 7 20 35 0 40 -24 49 -34 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxivsmdNq",
    d: "M886 2071 c-435 -435 -399 -384 -344 -495 l30 -59 369 369 c327 327 369 366 369 340 0 -24 2 -27 15 -16 12 10 15 38 15 131 l0 119 -33 0 c-29 0 -68 -36 -421 -389z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT3zeeIka",
    d: "M1310 2038 c0 -30 13 -58 26 -58 9 0 14 12 14 35 0 28 -4 35 -20 35 -11 0 -20 -6 -20 -12z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lktS82PT5K1Dl89wnAA1nW",
    fill: "rgb(254,109,86)",
    style: {
      transform: "none"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pROn4qf3D",
    d: "M2877 4262 c-378 -378 -417 -420 -417 -450 l0 -32 129 0 c102 0 131 3 141 15 11 13 8 15 -16 15 -26 0 17 46 370 399 l398 398 -73 30 c-41 17 -83 33 -94 37 -17 5 -97 -71 -438 -412z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16CPMLJKy",
    d: "M1867 3252 l-307 -307 0 -128 c0 -106 2 -127 15 -127 8 0 15 6 15 13 0 16 811 827 828 827 6 0 12 7 12 15 0 13 -21 15 -128 15 l-127 0 -308 -308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFDy1mC3N",
    d: "M2129 3030 c-15 -11 -34 -31 -43 -45 -16 -25 -16 -25 14 -25 20 0 30 5 30 15 0 8 7 15 15 15 10 0 15 10 15 30 0 35 2 35 -31 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AizzgELX",
    d: "M857 2242 l-418 -418 14 -40 c8 -22 25 -64 37 -93 l23 -53 399 399 c352 352 398 395 398 369 0 -24 2 -27 15 -16 12 10 15 39 15 141 l0 129 -33 0 c-29 0 -71 -39 -450 -418z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l4BoGQ9TG4cl2DwqSNImx2Z",
    fill: "rgb(254,124,78)",
    style: {
      transform: "none"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "phH92awNI",
    d: "M2717 4282 c-396 -397 -437 -440 -437 -470 l0 -32 119 0 c93 0 121 3 131 15 11 13 8 15 -16 15 -26 0 21 50 399 428 l428 428 -84 27 c-46 15 -87 27 -93 27 -5 0 -206 -197 -447 -438z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp7Xpa3Fe",
    d: "M1995 3550 c-11 -4 -113 -102 -227 -217 l-208 -209 0 -117 c0 -97 3 -117 15 -117 8 0 15 6 15 13 0 16 611 627 628 627 6 0 12 7 12 15 0 12 -18 15 -107 14 -60 0 -117 -4 -128 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzYkxUtNC",
    d: "M835 2400 l-439 -439 29 -91 29 -91 428 428 c378 378 428 425 428 399 0 -24 2 -27 15 -16 12 10 15 38 15 131 l0 119 -33 0 c-29 0 -72 -40 -472 -440z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5zAVliGyszPhva2EJ55xXl",
    fill: "rgb(254,134,72)",
    style: {
      transform: "none"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pfYd68Jam",
    d: "M2572 4297 c-410 -410 -452 -455 -452 -485 l0 -32 109 0 c84 0 111 3 121 15 11 13 8 15 -16 15 -26 0 24 52 421 450 294 294 444 451 435 454 -50 17 -127 36 -144 36 -14 0 -168 -147 -474 -453z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pt0hOjI7h",
    d: "M1931 3544 c-30 -8 -77 -27 -105 -42 -65 -34 -174 -142 -208 -208 -50 -92 -75 -234 -43 -234 8 0 15 8 15 17 0 26 418 441 452 448 15 4 28 13 28 21 0 18 -66 18 -139 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdKLHPr2S",
    d: "M822 2547 c-248 -248 -452 -459 -452 -467 0 -15 25 -120 36 -150 3 -9 156 137 454 435 398 397 450 447 450 421 0 -24 2 -27 15 -16 12 10 15 37 15 121 l0 109 -33 0 c-29 0 -73 -41 -485 -453z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5xlRuRiujADDgEFXCXmjuy",
    fill: "rgb(254,146,65)",
    style: {
      transform: "none"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1DPAdi04g",
    d: "M2382 4307 c-429 -429 -472 -475 -472 -505 l0 -32 133 6 c91 5 137 11 147 20 12 12 10 14 -15 14 -27 0 18 48 438 468 l468 468 -89 17 c-49 9 -100 17 -113 17 -18 0 -134 -110 -497 -473z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWwTLG9PG",
    d: "M1921 3544 c-62 -16 -151 -62 -158 -81 -3 -7 -11 -13 -17 -13 -15 0 -76 -62 -76 -77 0 -6 -6 -13 -13 -16 -32 -12 -97 -178 -97 -249 0 -51 28 -33 40 27 37 180 205 348 385 385 36 7 55 16 55 26 0 18 -47 18 -119 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRsH9wqr6",
    d: "M812 2737 c-384 -384 -472 -477 -472 -498 0 -29 30 -181 37 -189 2 -2 213 205 468 460 417 417 465 462 465 435 0 -25 2 -27 14 -15 9 10 15 56 20 148 l6 132 -33 0 c-29 0 -75 -43 -505 -473z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l1DigFcIMFRqFUuDYj9UTwH",
    fill: "rgb(254,161,56)",
    style: {
      transform: "none"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pUkuMPkf5",
    d: "M1466 3652 l-1149 -1150 6 -109 c4 -59 10 -125 13 -146 l7 -39 488 488 488 488 -6 -57 c-5 -53 -4 -57 16 -57 17 0 21 6 21 33 0 59 38 185 80 267 74 141 192 256 335 326 91 44 192 74 253 74 26 0 32 4 32 21 0 20 -4 21 -57 16 l-57 -6 488 488 488 488 -39 7 c-21 3 -87 9 -148 12 l-110 6 -1149 -1150z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRHYOrp96",
    d: "M1740 3429 l0 -30 30 21 c44 31 45 40 6 40 -33 0 -36 -2 -36 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSEhjMcWA",
    d: "M1660 3344 c0 -39 9 -38 40 6 l21 30 -30 0 c-29 0 -31 -3 -31 -36z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l55g5OtNYIQ7hpI8eLpjnZ5",
    fill: "rgb(254,176,47)",
    style: {
      transform: "none"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1HhhQgAYO",
    d: "M2455 4802 l-101 -3 -1017 -1017 -1017 -1017 -1 -153 c0 -85 1 -155 3 -157 2 -2 532 524 1178 1170 l1175 1175 -47 0 c-25 0 -52 1 -60 3 -7 1 -58 1 -113 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px68fUoVS",
    d: "M1830 3766 c-234 -82 -418 -271 -484 -495 -21 -70 -20 -81 3 -81 13 0 21 9 25 33 8 45 70 171 112 229 19 27 34 59 34 73 0 20 5 25 25 25 20 0 25 5 25 25 0 20 5 25 25 25 14 0 46 15 72 34 27 18 68 44 93 56 25 13 47 26 50 29 3 4 31 13 63 21 44 10 57 17 57 32 0 24 -20 23 -100 -6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l51nsAadzEf6Bb99iuU6quQ",
    fill: "rgb(254,192,38)",
    style: {
      transform: "none"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pGLqVeflS",
    d: "M2286 4789 c-38 -5 -112 -18 -165 -29 l-95 -19 -823 -823 -822 -822 -16 -71 c-18 -77 -48 -291 -43 -306 2 -5 473 461 1048 1036 915 915 1041 1045 1015 1044 -17 -1 -61 -6 -99 -10z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l263s79ihOm2JxxJphvB4N6",
    fill: "rgb(254,205,30)",
    style: {
      transform: "none"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p6HgeXYJx",
    d: "M2005 4735 c-114 -30 -285 -90 -344 -120 -32 -16 -215 -193 -597 -577 l-551 -553 -31 -75 c-37 -92 -86 -245 -105 -330 l-15 -63 869 869 c785 785 875 876 867 873 -2 0 -43 -11 -93 -24z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l56dXJfyIGv3E7bLezkq11n",
    fill: "rgb(254,216,23)",
    style: {
      transform: "none"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pPlQ7bRsu",
    d: "M1570 4572 c-383 -191 -689 -468 -915 -827 -58 -91 -180 -333 -173 -340 2 -2 283 275 623 615 341 341 615 620 610 620 -6 0 -71 -31 -145 -68z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5H7IWNyb09LQwGlHdBQHEZ",
    fill: "rgb(255,255,255)",
    style: {
      transform: "none"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "puE5WswMd",
    d: "M1975 3800 c-187 -28 -373 -133 -487 -274 -62 -77 -121 -192 -150 -292 -23 -78 -23 -83 -23 -674 0 -588 0 -596 23 -673 88 -306 325 -518 632 -567 103 -16 1107 -13 1200 4 163 30 293 98 410 216 87 87 140 167 180 278 48 133 52 188 48 792 -4 541 -5 557 -26 629 -83 272 -271 460 -544 543 -71 21 -86 22 -643 24 -313 1 -593 -1 -620 -6z m1207 -290 c167 -51 303 -199 338 -364 7 -36 10 -233 8 -617 -3 -563 -3 -564 -26 -621 -51 -125 -165 -239 -290 -290 -57 -23 -58 -23 -621 -26 -384 -2 -581 1 -617 8 -165 34 -313 172 -364 338 -19 61 -20 94 -20 616 0 601 1 614 58 720 35 65 133 164 198 198 104 56 112 57 715 57 528 1 560 0 621 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSCmp3lvY",
    d: "M2464 3191 c-244 -39 -446 -220 -520 -466 -25 -82 -25 -248 0 -329 56 -187 184 -336 354 -414 382 -176 821 63 890 484 14 84 14 104 0 188 -41 249 -215 448 -456 519 -65 20 -200 28 -268 18z m194 -255 c128 -35 232 -135 272 -262 25 -83 25 -145 0 -228 -40 -127 -144 -227 -272 -262 -139 -37 -294 12 -394 124 -13 15 -39 56 -56 92 -30 59 -33 73 -33 155 1 114 26 183 96 260 59 64 101 91 177 116 69 22 139 23 210 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDUHzlwBB",
    d: "M3173 1971 c-87 -54 -45 -191 58 -191 73 0 124 75 96 142 -18 44 -38 59 -84 64 -27 4 -47 -1 -70 -15z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/Inst.c86687da.svg";
export { ForwardRef as ReactComponent };